import _ from 'lodash';

function compareColumnsWidths(oldWidths: number[], newWidths: number[]): boolean {
  const oldSum = _.sum(oldWidths);
  const newSum = _.sum(newWidths);

  const oldProportions = oldWidths.map(width => _.round(width / oldSum * 100));
  const newProportions = newWidths.map(width => _.round(width / newSum * 100));

  return newProportions.every((newProportion, index) => {
    const oldProportion = oldProportions[index];

    return Math.abs(newProportion - oldProportion) <= 1;
  });
}

function compareRowsHeight(oldHeights: number[], newHeights: number[]): boolean {
  return newHeights.every((newHeight, index) => {
    const oldHeight = oldHeights[index];

    // no need to compare if there wasn't previous value
    if (!oldHeight) {
      return true;
    }

    return oldHeight === newHeight;
  });
}

function compareNotDefinedOrNull(oldValue: number, newValue: number): boolean {
  if (!oldValue && !newValue) {
    return true;
  }

  return oldValue === newValue;
}

function compareAbbreviations(oldAbbreviations: string[], newAbbreviations: string[]): boolean {
  return _.isEqual(oldAbbreviations, newAbbreviations);
}

function getKeysToCompare(a, b): (string | number)[] {
  return Object.keys({ ...a, ...b })
    .filter(key => ![null, undefined].includes(a[key]) || ![null, undefined].includes(b[key]));
}

function compareBorder(oldBorder, newBorder): boolean {
  const keysToCompare = getKeysToCompare(oldBorder, newBorder);

  return keysToCompare.every(key => _.isEqual(oldBorder[key], newBorder[key]));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function stylesComparator(oldValue: any, newValue: any, propName: string): boolean | undefined {
  const oldIsNil = oldValue === undefined || oldValue === null;
  const newIsNil = newValue === undefined || newValue === null;
  if (oldIsNil && newIsNil) {
    return true;
  }

  switch (propName) {
    case 'backgroundColorTint': return compareNotDefinedOrNull(oldValue, newValue);
    case 'columnsWidth': return compareColumnsWidths(oldValue, newValue);
    case 'rowsHeight': return compareRowsHeight(oldValue, newValue);
    case 'abbreviations': return compareAbbreviations(oldValue, newValue);
    case 'backgroundColor': return compareNotDefinedOrNull(oldValue, newValue);
    case 'border': return compareBorder(oldValue, newValue);
    default: return undefined;
  }
}
